<template>
    <div>
        <div v-if="showInfoFooter" class="additional-footer">
            <img src="img/Bienestar.png" alt="" width="100%" height="100%">
        </div>
        <div class="footer-links-container container wide space-around">
            <div class="container column center">
                <div class="footer-container column">
                    <router-link to="/preguntas-frecuentes" class="footer-content strong-font">Preguntas frecuentes</router-link>
                    <router-link to="/quienes-somos" class="footer-content strong-font">Quiénes somos</router-link>
                    <router-link to="/aviso-de-privacidad"  class="footer-content strong-font" >Aviso de privacidad</router-link>
                    <router-link to="/aviso-de-privacidad"  class="footer-content strong-font">Terminos y condiciones</router-link>
                </div>
            </div>
            <div class="container column center">
                <div class="footer-container column">
                    <div class="footer-container strong-font">Ayuda</div>
                    <router-link to="/cambios-y-devoluciones" class="footer-content">Cambios y devoluciones</router-link>
                    <router-link to="/facturacion-electronica" class="footer-content">Facturación electronica</router-link>
                    <router-link to="/comentarios-y-sugerencias" class="footer-content">Comentarios y sugerencias</router-link>
                    <router-link to="/gofarma-en-tu-empresa" class="footer-content">GoFarma en tu empresa</router-link>
                </div>
            </div>
            <div class="container column center">
                <div class="footer-container column">
                    <div class="container">
                        <div class="footer-content" @click="PhoneCall()"><i class="fa fa-phone footer-icon"/><span class="white">81 8353 2639</span></div>
                        <div class="footer-content"><i class="fab fa-facebook footer-icon"/><span class="white">/GoFarmaOficial</span></div>
                    </div>
                    <div class="container" style="padding-top: 0.5em">
                        <div class="footer-content" @click="OpenWhatsAppMessenger()"><i class="fab fa-whatsapp footer-icon" style="margin-left:0rem"/><span class="white">811 764 0845</span></div>
                        <div class="footer-content"><i class="footer-icon fab fa-instagram"/><span class="white">@gofarma</span></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-text">
            Consulte a su médico. Evite automedicarse.<br>
            La lactancia materna es el principal alimento para el bebé.
            <div class="copyright">
                © 2019 GoFarma. Todos los derechos reservados.
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions, mapState} from 'vuex';
export default {
    name:'Footer',
    computed:{
        ...mapActions(['PhoneCall','OpenWhatsAppMessenger']),
        ...mapState(['showInfoFooter'])
    }
}
</script>
<style>
@import '../variables.css';

.additional-footer{
     background:var(--light-blue);
     padding:0;
     margin:0;
     height:100%;
}

.footer-links-container{
    background: var(--dark-gofarma);
    padding-top: 1em;
    padding-bottom: 1em;
}

.fa-phone, .fa-whatsapp, .fa-instagram, .fa-facebook{
    color: #fafafa;
}

.copyright{
    padding-top:1rem;
}

.footer-container a{
    color:#fafafa;
    padding-top:.3rem;
}
.footer-container{
    padding-top:.3rem;
    text-align:left;
}
.strong-font{
    font-weight: bold;
}

.strong-font{
    color:#fafafa;
}

.footer-text{
    text-align:left;
    padding: 0.9375rem 8%;
    box-sizing: border-box;
    font-weight: bold;
    font-size:1rem;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
}

ol, ul {
    list-style: none;
}

ul {
    text-align: left;
    display: block;
    font-size: 1.25rem;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0;
    margin-inline-end: 0;
    padding-inline-start: 2.5rem;
}

.page-footer a {
    color: white;
    text-decoration: none;
}

@media (max-width: 44.5rem){
    .footer-links-container { 
        flex-direction: column;
    }
    .footer-container{
        text-align: center;
    }
}
</style>